import React, { useContext } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import DataRoomContext from 'router/subrouters/DataRoom/providers/DataRoom/DataRoom.context';
import WhitelabelingBanner from 'router/subrouters/DataRoom/components/WhitelabelingBanner';
import ManageKeyFeatures from './components/ManageKeyFeatures';
import Snapshots from './components/Snapshots';
import DocumentsGlobalSecurity from './components/DocumentsGlobalSecurity';
import { Navigate } from 'react-router-dom';
import { getDataRoomRoute } from 'utils';
import CurrentUserContext from 'providers/CurrentUser/CurrentUser.context';
import DataRoomSetup from './components/DataRoomSetup';
import OnboardingContext from 'router/subrouters/DataRoom/providers/Onboarding/Onboarding.context';

import './SetupPage.styles.scss';
import './SetupPage.styles.responsive.scss';

type SetupPageProps = {
  className?: string;
};

const SetupPage: React.FC<SetupPageProps> = (props) => {
  const { className } = props;

  const { hasEnterpriseLogo } = useContext(CurrentUserContext);
  const { isAdmin, dataRoom } = useContext(DataRoomContext);
  const { contentCard } = useContext(OnboardingContext);

  const { _id, isWhitelabeled } = dataRoom;

  const classes = classNames('setup-page', 'page', className);

  const { t } = useTranslation();

  if (!isAdmin)
    return <Navigate to={getDataRoomRoute(_id, 'documents')} replace />;

  return (
    <div className={classes}>
      <div
        className={classNames('setup-page__heading', {
          'has-enterprise': hasEnterpriseLogo,
        })}
      >
        <h2>{t('settings')}</h2>
        {!isWhitelabeled && <WhitelabelingBanner />}
      </div>

      {contentCard}
      <DataRoomSetup />
      <DocumentsGlobalSecurity />
      <Snapshots />
      <ManageKeyFeatures />
    </div>
  );
};

export default SetupPage;
